import * as Types from '@trello/graphql/generated';

import DocumentNode from '@trello/graphql/src/documentNode';
import * as Apollo from '@apollo/client';
import process from 'process';
export type BoardAutoArchivePrefFragment = (
  { __typename: 'Board' }
  & Pick<Types.Board, 'id'>
  & { prefs?: Types.Maybe<(
    { __typename: 'Board_Prefs' }
    & Pick<Types.Board_Prefs, 'autoArchive'>
  )> }
);

export const BoardAutoArchivePrefFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BoardAutoArchivePref' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Board' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'prefs' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'autoArchive' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

interface UseBoardAutoArchivePrefFragmentOptions
  extends Omit<
    Apollo.UseFragmentOptions<
      BoardAutoArchivePrefFragment,
      Apollo.OperationVariables
    >,
    'fragment' | 'fragmentName' | 'from'
  > {
  from: Apollo.StoreObject | Apollo.Reference;
  returnPartialData?: boolean;
}

interface UseBoardAutoArchivePrefFragmentResult
  extends Omit<Apollo.UseFragmentResult<BoardAutoArchivePrefFragment>, 'data'> {
  data?: BoardAutoArchivePrefFragment;
}

export const useBoardAutoArchivePrefFragment = ({
  from,
  returnPartialData,
  ...options
}: UseBoardAutoArchivePrefFragmentOptions): UseBoardAutoArchivePrefFragmentResult => {
  const result = Apollo.useFragment<BoardAutoArchivePrefFragment>({
    ...options,
    fragment: BoardAutoArchivePrefFragmentDoc,
    fragmentName: 'BoardAutoArchivePref',
    from: {
      __typename: 'Board',
      ...from,
    },
  });

  // Ensure that the fragment result is not typed as a DeepPartial.
  if (!result.complete && !returnPartialData) {
    if (process.env.NODE_ENV === 'development') {
      console.warn('Fragment data is incomplete.', result);
    }
    return {
      ...result,
      data: undefined,
    };
  }

  return { ...result, data: result.data as BoardAutoArchivePrefFragment };
};
